import { Menu, MenuItem, Box } from '@mui/material';
import React from 'react';
import { MoreActionsHorizontal } from '@sweep-io/sweep-design/dist/icons';
import { IconButton, Tooltip } from '@sweep-io/sweep-design';
import { AiAgent } from './aiAgentsConsts';
import usePopover from '../../hooks/usePopover';
import { useAgentActions } from './useAgentActions';

interface AgentCardMenuProps {
  isCardHovered: boolean;
  agent: AiAgent;
}

const AgentCardMenu = ({ isCardHovered, agent }: AgentCardMenuProps) => {
  const { closePopover, isPopoverOpen, openPopover, anchorRef, anchorElement } = usePopover();
  const { renameAction, deleteAction, renameDialog } = useAgentActions(agent, {
    origin: 'agent_card',
    mode: 'expanded',
  });

  const cardActions = [{ action: renameAction, label: 'Rename' }];

  if (deleteAction) {
    cardActions.push({ action: deleteAction, label: 'Delete' });
  }

  return (
    <>
      {renameDialog}

      <Box
        ref={anchorRef}
        sx={{
          position: 'absolute',
          zIndex: 100,
          right: '10px',
          top: '10px',
          display: isPopoverOpen || isCardHovered ? 'block' : 'none',
        }}
      >
        <IconButton variant="system" size="tiny" onClick={openPopover} pressed={isPopoverOpen}>
          <MoreActionsHorizontal />
        </IconButton>
      </Box>

      <Menu
        anchorEl={anchorElement}
        open={isPopoverOpen}
        onClose={closePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 22,
        }}
        slotProps={{
          paper: {
            style: {
              width: '157px',
            },
            onClick: (e: React.MouseEvent) => {
              e.stopPropagation();
            },
          },
        }}
      >
        {cardActions.map((item) => (
          <Tooltip
            key={item.label}
            title={item.action.disabled ? item.action.disabledTooltip : undefined}
            placement="left"
          >
            <span>
              <CardMenuItem
                text={item.label}
                disabled={item.action.disabled}
                onClick={() => {
                  if (!item.action.disabled) {
                    item.action.onClick();
                  }
                  closePopover();
                }}
                color={item.action.color}
              />
            </span>
          </Tooltip>
        ))}
      </Menu>
    </>
  );
};

export default AgentCardMenu;

const CardMenuItem = ({
  onClick,
  text,
  disabled,
  color,
}: {
  onClick: (event: any) => void;
  text: string;
  disabled?: boolean;
  color?: string;
}) => {
  return (
    <MenuItem
      disableRipple
      disableGutters
      disabled={disabled}
      onClick={onClick}
      sx={{
        color,
      }}
    >
      {text}
    </MenuItem>
  );
};
